function onDeviceReady() {
  return import("@/main-deviceready");
}

if (window.cordova) {
  document.addEventListener("deviceready", onDeviceReady, false);
} else {
  document.addEventListener("DOMContentLoaded", onDeviceReady, false);
}
